import React, { Fragment } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { Form, Text, Number, Checkbox, DateTimePicker, Select, WeekdayPicker } from 'components/forms'
import { ImageUploaderGraphql } from 'components/Image'
import Button from 'components/Button'
import { ContentBlock } from 'components/ContentBlock'
import Divider from 'components/Divider'
import get from 'helpers/get'
import { getMedia } from '../gql'
import listTags from 'gql/query/listTags'
import TagEditor from 'components/TagEditor'
import { listProducts } from 'sections/product/gql/query'
import { loadAppConstants, listShops } from 'gql/query'
import { useTranslation } from 'react-i18next'
import ImgUploaderWithDimensions from '../fragments/ImgUploaderWithDimensions'
import { CustomRow, CustomCol } from './styled'

const Media = ({ appData, data, formData, itemId, onChangeMultiEdit, apiRef, ConfirmButton, ConfirmModal, newRecord, mutations: { createItem, updateItem }, multiEdit }) => {
	const [t, i18n] = useTranslation()
	const img = get(['img', 'key'], data)
	const img16_9 = get(['img16_9', 'key'], data)
	const handleSubmit = ({ withProducts, ...values }) => {
		const payload = {
			...values,
			productsId: (withProducts || []).map(({ id }) => id)
		}
		return newRecord ? createItem(payload) : updateItem(payload)
	}
	return(
		<ContentBlock>
			<Form
				apiRef={apiRef}
				smartSubmit={(!newRecord && !multiEdit?.isActive)}
				onChange={(e) => multiEdit?.isActive && onChangeMultiEdit(e, formData)}
				initialValues={formData}
				onSubmit={handleSubmit}
				render={({ formState }) => (
					<Fragment>
						<Row>
							<Col xs>
								<Text
									field='name'
									disabled={multiEdit?.isActive}
									label={t('common.fields.name')}
									placeholder={t('common.placeholders.name')}/>
								<Checkbox
									field='isActive'
									label={t('common.fields.isActive')}/>
								<Select
									inline
									style={{ width: '260px' }}
									field='tagId'
									isClearable
									valueField='id'
									labelField='name'
									remoteOptions={{
										query: listTags,
										variables: { type: 'MediaTag' }
									}}
									label={t('media_section.fields.group_tag')}
								/>
								{ConfirmModal()}
								<TagEditor tagType='MediaTag'/>
								<div>
									{!newRecord && <Fragment>
										<Number
											label={t('media_section.strings.img_effect')} field='refreshTime'
											placeholder={t('media_section.fields.img_effect_duration')}
											inline
											shrink/>
										<Select
											field='animationType'
											placeholder={t('media_section.fields.img_effect_type')}
											remoteOptions={{
												query: loadAppConstants,
												variables: { type: 76, language: i18n.language }
											}}
											inline
											shrink
										/>
									</Fragment>}
								</div>
							</Col>
							<Col xs>
								<DateTimePicker
									field='dateInterval'
									interval
									label={{ from: t('common.fields.from_date'), to: t('common.fields.to_date') }}
									placeholder={{ from: t('common.placeholders.from_date'), to: t('common.placeholders.to_date') }}
								/>
								<Checkbox inline
									field='stayActive'
									label={t('media_section.fields.stay_active')}
								/>
								<DateTimePicker
									field='timeInterval'
									interval
									picker='time'
									label={{ from: t('common.fields.from_time'), to: t('common.fields.to_time') }}
									placeholder={{ from: t('common.placeholders.from_time'), to: t('common.placeholders.to_time') }}
								/>
								{appData.isShopFieldActive &&
									<Select
										label={t('common.fields.shop_affiliation')}
										field='shopId'
										valueField='id'
										labelField='name'
										validate={val => !val && appData.shopAccess ? t('validators.required') : null}
										remoteOptions={{
											query: listShops,
											modifyOptions: (options => {
												return options
													.map(opt => opt.codePrefix ? ({ ...opt, name: `${opt.name} - "${opt.codePrefix}"` }) : opt)
											})
										}}
										isClearable={!appData.shopAccess}
									/>
								}
							</Col>
							<Col xs>
								<WeekdayPicker
									field='weekDays'
									label={t('common.fields.week_days')}
									placeholder={t('common.placeholders.week_days')}
								/>
							</Col>
						</Row>
						{ConfirmButton(formState)}
						{!newRecord && <Fragment>
							<Divider visible />
							<CustomRow>
								<CustomCol xs>
									<ImgUploaderWithDimensions
										label={t('media_section.fields.img_full_screen')}
										id={itemId}
										getQuery={getMedia}
										field='img16_9'
										parent='Media'
										imgKey={img16_9}
										disabled={multiEdit?.isActive}
										elementMaxWidth={300}
									/>
								</CustomCol>
								<CustomCol xs>
									<ImageUploaderGraphql
										label={t('media_section.fields.img')}
										parent='Media'
										type='Media'
										getQuery={getMedia}
										field='img'
										id={itemId}
										imgKey={img}
										width={756}
										height={1080}
										elementMaxWidth={156}
									/>
								</CustomCol>
								<CustomCol xs style={{ flexBasis: '300px' }}>
									<Select
										remoteOptions={{
											query: listProducts,
											variables: { params: { limit: 100 } }
										}}
										simpleValue={false}
										withVirtualBody
										disabled={multiEdit?.isActive}
										isMulti
										isSearchable
										label={t('media_section.fields.product_list')}
										placeholder={t('common.placeholders.select_default')}
										field='withProducts'
										maxMenuHeight={250}
										valueField='id'
										labelField='name'
									/>
								</CustomCol>
							</CustomRow>
						</Fragment>}
						{newRecord &&
							<Col type='row'>
								<Button
									type='submit'
									status='primary'
									text={t('common.buttons.create')}/>
							</Col>
						}
					</Fragment>
				)}
			/>
		</ContentBlock>
	)
}

export default Media
